import { defineMessages } from 'react-intl';

export const SEGMENTSELECTOR_MESSAGES = defineMessages({
  addSegment: {
    defaultMessage: 'Add',
    description:
      'Aria-label for the + in the "add segment" button to convey the functionality.',
    id: 'SzcXIJL/aWzjy5Ig',
  },
  arrayIdentifierError: {
    id: 'eYRqhWFzgj9ne5TC',
    defaultMessage: 'The first column of a variable cannot be an array.',
    description:
      'Error message shown when a segment variable is identified by a first column array.',
  },
  applyButton: {
    defaultMessage: 'Apply',
    description:
      'Button in the SegmentSelector overlay to apply the segment selection.',
    id: 'DswaMGT7rt2ajcbI',
  },
  clearAll: {
    defaultMessage: 'Clear all',
    description: 'Label for the clear all button.',
    id: 'e2L/mGCBvRqDTvq2',
  },
  clearSegments: {
    defaultMessage: 'Clear segments',
    description:
      'Label for the clear segments button when segments are applied but the user has no permissions.',
    id: 'WxdPgLpYTL0pyM92',
  },
  copyDetailsButton: {
    id: 'OVHWs31OggLCgWSq',
    defaultMessage: 'Copy details',
    description: 'Label for the copy details button in SegmentsOverlay.',
  },
  copyDetailsHint: {
    id: 'bx7cExKj4X9tpZgs',
    defaultMessage: 'Please copy the details and share them with your admin.',
    description: 'Hint to copy details to share with an admin.',
  },
  defaultAriaLabel: {
    defaultMessage: 'Filter by segments',
    description:
      'Text for SegmentSelector Trigger when no segment is selected yet.',
    id: 'q/AKqzat66d0tRr7',
  },
  docsLinkText: {
    defaultMessage: 'Learn more about segments',
    description: 'Display text for the link to the segments documentation.',
    id: 'ZFLXYT4zoCbKvGNP',
  },
  docsLinkTextShort: {
    defaultMessage: 'Learn more',
    description:
      'Short version of the display text for the link to the segments documentation.',
    id: 'Xxl1F0GNIQlu2LSH',
  },
  emptyString: {
    defaultMessage: 'Empty value',
    description:
      'Display text for segment variable values that are an empty string.',
    id: 'wtm8N4m0hully7OX',
  },
  filteredSegmentNotFound: {
    defaultMessage:
      'No matching segments found. If you’re looking for a segment value, select the segment first.',
    description:
      "Hint shown when searching for a segment variable that isn't in the list.",
    id: 'ovlsWnQ6TNpxUzyF',
  },
  genericSegmentError: {
    defaultMessage:
      'The applied segments are outdated. Please check your selection in the overlay.',
    description:
      'Error message indicating that something with the current selection is wrong and, therefore, should be checked.',
    id: 'LhnAiI2sqynNbsba',
  },
  legend: {
    defaultMessage: 'Filter by segments',
    description: 'FieldSet Label in SegmentSelector Overlay.',
    id: '+uTtPJkLATW51CDB',
  },
  linkMenuTrigger: {
    defaultMessage: 'Open to find further resources',
    description:
      'Aria-label for menu trigger for collapsed resource links on mobile.',
    id: 'ymTPa3UIE2oxpoEr',
  },
  loadingAriaLabel: {
    defaultMessage: 'Loading segments',
    description:
      'Aria-label for the loading view within the SegmentSelector Overlay.',
    id: 'iygPRzX1n+gL7TLR',
  },
  manageSegments: {
    defaultMessage: 'Manage segments',
    description: 'Display text for the link to the SegmentsManager app.',
    id: 'MsfOpUQyZ0eEZ/5T',
  },
  moreTooltip: {
    defaultMessage: '+{number} more',
    description:
      'Tooltip message when the tooltip is too big and shows the first selected segment and +X more for the remaining.',
    id: 'GFd2oJ+U46/o0aMy',
  },
  noAccessNoSegments: {
    id: 'eJrsgl5/4XpLIWxo',
    defaultMessage:
      "Your assigned access control policies don't permit you to use segments.",
    description:
      'Message shown when access control permissions are missing and no segments are applied.',
  },
  noReadAccess: {
    id: 'ExRdGipMUK2Tldxd',
    defaultMessage:
      "Segments are applied but your assigned access control policies don't permit you to read them.",
    description:
      'Message shown when access control permissions (read) are missing and segments are already applied.',
  },
  noReadAndWriteAccess: {
    id: 'mtKUJAn0mf0dbG4E',
    defaultMessage:
      "Your assigned access control policies don't permit you to read or apply segments.",
    description:
      'Message shown when access control permissions are missing but a query with segments was run.',
  },
  noSegmentsConfigured: {
    defaultMessage: 'No segments configured.',
    description: 'Message shown in the empty state of the segmentsSelector.',
    id: 'Mexo5VI0BZU5Mw8b',
  },
  noSegmentVariablesAvailable: {
    defaultMessage:
      'No values for this segment available. You can manage this segment in settings.',
    description:
      'Empty state message if no variables for the segment are available.',
    id: 'RoNWrUBQf8gR7lxZ',
  },
  pinButton: {
    defaultMessage: 'Pin',
    description: 'Text for the pin button of a segment preset.',
    id: 'L4FYL0HqCIFzBkzf',
  },
  removedVariablesError: {
    defaultMessage:
      'This segment is no longer using variables. Click apply to refresh it.',
    description:
      'Error message shown when the selected segment has variables but does not expect any.',
    id: 'aGMowcWvdm+5M63D',
  },
  removeSegmentButton: {
    defaultMessage: 'Remove segment',
    description: 'Aria-label for the remove button of a segments select.',
    id: 'S6z4dIJ7FiELVt5X',
  },
  segmentsSelectEmptyState: {
    defaultMessage: 'No other segments available.',
    description: 'Message shown if all available segments have been selected.',
    id: 'CzhNdiuuquVgEUTg',
  },
  segmentsSelectEmptyStateSearch: {
    defaultMessage:
      'No matching segments found. If you’re looking for a segment value, select the segment first.',
    description: 'Message for an empty search result in the segment select.',
    id: 'yJBeHrP0dl2h/JIx',
  },
  segmentsTriggerPlaceholder: {
    defaultMessage: 'Select segment',
    description:
      'Placeholder for the trigger of the select within the segmentSelector Overlay.',
    id: 'oSKhN7fSy19ei878',
  },
  segmentsVariableTriggerPlaceholder: {
    defaultMessage: 'Select value',
    description:
      'Placeholder for the trigger of the select within the segmentSelector Overlay.',
    id: 'RuGHpilISAqb1dDM',
  },
  unavailable: {
    defaultMessage: 'Unavailable',
    description:
      'Description for unavailable segment variables, e.g. if the variable is not available any longer.',
    id: 'K+rYESaxckSqgeF/',
  },
  unavailableSegmentError: {
    defaultMessage:
      "This segment doesn't exist anymore. Please remove it from the selection.",
    description:
      'Error message if the segment was removed but is still selected.',
    id: '+kn/ILSk7yxtVqQ/',
  },
  unlistedSegmentTooltip: {
    defaultMessage:
      'Someone else applied this segment, which is usually not available to you. You can only view or remove it.',
    description: 'Description for the tooltip of an unlisted segment.',
    id: 'UdBwDtbEgD8ojnmL',
  },
  valueMissingError: {
    defaultMessage: 'At least one value must be selected.',
    description: 'Error message shown when no value is selected.',
    id: 'qDnh6SFkeo10shlI',
  },
});
